import React, { useState } from "react";

function PostTable({ posts, sortOption, handleSortChange, getButtonClass }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(posts.length / itemsPerPage);
  const currentPosts = posts.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="mt-4">
      <label className="mr-2 text-lg font-semibold">Sort by:</label>
      <button
        onClick={() => handleSortChange("date")}
        className={`px-4 py-2 rounded-lg mr-2 transition-colors duration-300 ${
          sortOption === "date"
            ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white"
            : "bg-gray-200 text-black"
        }`}
      >
        Date
      </button>
      <button
        onClick={() => handleSortChange("likes")}
        className={`px-4 py-2 rounded-lg mr-2 transition-colors duration-300 ${
          sortOption === "likes"
            ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white"
            : "bg-gray-200 text-black"
        }`}
      >
        Likes
      </button>
      <button
        onClick={() => handleSortChange("comments")}
        className={`px-4 py-2 rounded-lg mr-2 transition-colors duration-300 ${
          sortOption === "comments"
            ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white"
            : "bg-gray-200 text-black"
        }`}
      >
        Comments
      </button>
      <button
        onClick={() => handleSortChange("shares")}
        className={`px-4 py-2 rounded-lg mr-2 transition-colors duration-300 ${
          sortOption === "shares"
            ? "bg-gradient-to-r from-blue-500 to-purple-600 text-white"
            : "bg-gray-200 text-black"
        }`}
      >
        Shares
      </button>

      <div className="mt-4">
        <h3 className="text-xl font-semibold mb-4">Engagement Data</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-blue-50 shadow-md rounded-lg">
            <thead>
              <tr className="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white">
                <th className="text-left p-3 rounded-tl-lg">Post #</th>
                <th className="text-left p-3">Message</th>
                <th className="text-left p-3">Created Time</th>
                <th className="text-left p-3">Likes</th>
                <th className="text-left p-3">Comments</th>
                <th className="text-left p-3">Shares</th>
                <th className="text-left p-3 rounded-tr-lg">Total Engagement</th>
              </tr>
            </thead>
            <tbody>
              {currentPosts.map((post, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-300 hover:bg-gradient-to-r hover:from-blue-100 hover:to-purple-100 transition-colors duration-200"
                >
                  <td className="p-3">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td className="p-3">
                    {post.message ? post.message : "No message available"}
                  </td>
                  <td className="p-3">
                    {new Date(post.created_time).toLocaleString()}
                  </td>
                  <td className="p-3">
                    {post.likes ? post.likes.summary.total_count : 0}
                  </td>
                  <td className="p-3">
                    {post.comments ? post.comments.summary.total_count : 0}
                  </td>
                  <td className="p-3">
                    {post.shares ? post.shares.count : 0}
                  </td>
                  <td className="p-3">{post.engagement !== undefined ? post.engagement : 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-end mt-4 space-x-2">
          <button
            onClick={handlePreviousPage}
            disabled={currentPage === 1}
            className="px-4 py-2 bg-gray-200 rounded text-black disabled:opacity-50"
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              onClick={() => handlePageChange(index + 1)}
              className={`px-4 py-2 rounded ${
                currentPage === index + 1 ? "bg-blue-500 text-white" : "bg-gray-200 text-black"
              }`}
            >
              {index + 1}
            </button>
          ))}
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="px-4 py-2 bg-gray-200 rounded text-black disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default PostTable;
